import React from 'react';
import Card from '../../components/ui/Card.jsx';
import Button from '../../components/ui/Button.jsx';
import Modal from '../../components/ui/Modal.jsx';
import { apiFetch } from '../../api.js';
import { useApi } from '../../hooks/useApi.js';

export default function StaffLogs() {
  const [refresh, setRefresh] = React.useState(0);
  const { data, loading, error } = useApi('/api/logs', [refresh]);
  const [message, setMessage] = React.useState('');
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [clearing, setClearing] = React.useState(false);
  const rawLogs = data?.raw || '';
  const hasLogs = rawLogs.trim().length > 0;

  const handleClear = async () => {
    setMessage('');
    setClearing(true);
    try {
      await apiFetch('/api/logs/clear', { method: 'POST' });
      setRefresh((value) => value + 1);
      setConfirmOpen(false);
    } catch (err) {
      setMessage(err?.message || 'Failed to clear logs.');
    } finally {
      setClearing(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Server Logs</h1>
          <p className="subtle">Monitor system activity and errors.</p>
        </div>
        <Button
          variant="secondary"
          type="button"
          onClick={() => setConfirmOpen(true)}
          disabled={loading || !hasLogs}
        >
          Clear Logs
        </Button>
      </div>
      {error ? <div className="alert error">{error}</div> : null}
      {message ? <div className="alert error">{message}</div> : null}
      <Card title="Recent Entries">
        {loading ? (
          <pre className="log-viewer">Loading...</pre>
        ) : hasLogs ? (
          <pre className="log-viewer">{rawLogs}</pre>
        ) : (
          <p className="subtle">No log entries yet.</p>
        )}
      </Card>
      <Modal
        open={confirmOpen}
        title="Clear server logs?"
        onClose={() => setConfirmOpen(false)}
        actions={(
          <>
            <Button variant="secondary" type="button" onClick={() => setConfirmOpen(false)}>
              Cancel
            </Button>
            <Button variant="danger" type="button" onClick={handleClear} disabled={clearing}>
              {clearing ? 'Clearing...' : 'Clear Logs'}
            </Button>
          </>
        )}
      >
        <p>This action permanently removes all server log entries. This cannot be undone.</p>
      </Modal>
    </div>
  );
}
